
export const name = 'account-api-config'
export const api = {
  account: {
    info: `/api/v2/agent/user/current`, // get
    updateInfo: `/api/v2/bud/user/editUser`, // post
    refreshLogin: `/api/v2/bud/login/refresh-login`, // post
    queryResource: `/api/v2/bud/company/queryResource` // get 获取个人中心资源权限列表
  },
  login: {
    login: `/api/v2/bud/loginMobile`, // post
    firstFactorLogin: `/api/v2/bud/loginMobileForTwoFactorAuth`,
    verifyTotp: `/api/v2/bud/loginMobile/totp`
    // logout: ``
  },
  reset: {
    getCheckCode: `/api/v2/bud/send-code`, // post
    inspectPhone: `/api/v2/bud/phone/check-account`, // get 检查账号是否存在
    getCode: `/api/v2/bud/check-code`, // post
    resetPassword: `/api/v2/bud/login/resetPassword`, // post
    updatePassword: `/api/v2/bud/current/updatePassword` // post修改密码
  },
  company: {
    getCompanyList: `/api/v2/bud/company/search`, // post
    changeCurrentCompany: `/api/v2/bud/company/change-current`, // get
    getCompanyDetail: `/api/v2/bud/company/queryCompany/:id`, // get
    getBanner: `/api/v2/bud/banner/queryBannerByUser`, // get
    getStaffList: `/api/v2/bud/company/get-user-by-company-id`, // get  获取员工列表
    queryIpConfig: `/api/v2/bud/conf/get-ip-port` // get 获取系统配置
  }
}
